'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'star-half';
var width = 576;
var height = 512;
var aliases = [61731];
var unicode = 'f089';
var svgPathData = ['M288.2-52.8l92.6 181.4 195.4 31.1 0 6.6C530.1 212.4 484 258.5 438 304.7l31.7 201.2c-60.5-30.8-121-61.6-181.5-92.3 0-155.5 0-310.9 0-466.3z', 'M288.2-52.8l0 0-92.6 181.4-201.1 32 143.9 144.1-31.7 201.2 181.5-92.3 0 0 0-466.3zm288 219.1l5.7-5.7-5.7-.9 0 6.6z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarHalf = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;